import './CompRichText.css'

import { CompRichTextCore } from '../core/rich-text/comp'

export const CompRichText = CompRichTextCore
